import FAQ from '../../components/Help/FAQ';

const FAQPage = () => {
  return <FAQ />;
};

export default FAQPage;
